var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { debounce, isNil } from 'lodash-es';
import { appendStylesToTheStyleRoot, fastDom } from '../utilities/dom';
import stylesGlobal from './_sds-tabs-global.lit.scss';
import styles from './sds-tabs.lit.scss';
import { roundTabCoordinates } from './tabs-calculations';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-tabs` provides a tabbed navigation interface, allowing users to switch between different views or sections within a component.
 *
 * ### Attributes
 * - `selected-tab-index`: Sets or reflects the currently selected tab index.
 *
 * @tag sds-tabs
 */
let SdsTabs = (() => {
    var _SdsTabs_isFixedHeader_accessor_storage, _SdsTabs__selectedTabIndex_accessor_storage, _SdsTabs__tabTitles_accessor_storage, _SdsTabs__panels_accessor_storage, _SdsTabs__transform_accessor_storage, _SdsTabs__sdsTabPrev_accessor_storage, _SdsTabs__sdsTabNext_accessor_storage, _SdsTabs__sdsHeaderDiv_accessor_storage, _SdsTabs__slotElement_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tabs')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _isFixedHeader_decorators;
    let _isFixedHeader_initializers = [];
    let _isFixedHeader_extraInitializers = [];
    let __selectedTabIndex_decorators;
    let __selectedTabIndex_initializers = [];
    let __selectedTabIndex_extraInitializers = [];
    let __tabTitles_decorators;
    let __tabTitles_initializers = [];
    let __tabTitles_extraInitializers = [];
    let __panels_decorators;
    let __panels_initializers = [];
    let __panels_extraInitializers = [];
    let __transform_decorators;
    let __transform_initializers = [];
    let __transform_extraInitializers = [];
    let __sdsTabPrev_decorators;
    let __sdsTabPrev_initializers = [];
    let __sdsTabPrev_extraInitializers = [];
    let __sdsTabNext_decorators;
    let __sdsTabNext_initializers = [];
    let __sdsTabNext_extraInitializers = [];
    let __sdsHeaderDiv_decorators;
    let __sdsHeaderDiv_initializers = [];
    let __sdsHeaderDiv_extraInitializers = [];
    let __slotElement_decorators;
    let __slotElement_initializers = [];
    let __slotElement_extraInitializers = [];
    let _set_selectedTabIndex_decorators;
    var SdsTabs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTabs_isFixedHeader_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _isFixedHeader_initializers, false)));
            _SdsTabs__selectedTabIndex_accessor_storage.set(this, (__runInitializers(this, _isFixedHeader_extraInitializers), __runInitializers(this, __selectedTabIndex_initializers, undefined)));
            this._stylesGlobal = (__runInitializers(this, __selectedTabIndex_extraInitializers), stylesGlobal);
            _SdsTabs__tabTitles_accessor_storage.set(this, __runInitializers(this, __tabTitles_initializers, void 0));
            _SdsTabs__panels_accessor_storage.set(this, (__runInitializers(this, __tabTitles_extraInitializers), __runInitializers(this, __panels_initializers, void 0)));
            _SdsTabs__transform_accessor_storage.set(this, (__runInitializers(this, __panels_extraInitializers), __runInitializers(this, __transform_initializers, 0)));
            _SdsTabs__sdsTabPrev_accessor_storage.set(this, (__runInitializers(this, __transform_extraInitializers), __runInitializers(this, __sdsTabPrev_initializers, void 0)));
            _SdsTabs__sdsTabNext_accessor_storage.set(this, (__runInitializers(this, __sdsTabPrev_extraInitializers), __runInitializers(this, __sdsTabNext_initializers, void 0)));
            _SdsTabs__sdsHeaderDiv_accessor_storage.set(this, (__runInitializers(this, __sdsTabNext_extraInitializers), __runInitializers(this, __sdsHeaderDiv_initializers, void 0)));
            _SdsTabs__slotElement_accessor_storage.set(this, (__runInitializers(this, __sdsHeaderDiv_extraInitializers), __runInitializers(this, __slotElement_initializers, void 0)));
            this._sdsHeaderDivCoordinates = __runInitializers(this, __slotElement_extraInitializers);
            this._moveLength = 220;
            this.directionChangeObserver = new MutationObserver((mutations) => {
                if (mutations[0].oldValue !== mutations[0].target.getAttribute('dir')) {
                    this.clickHandler(this._moveLength);
                }
            });
            this.initPositioningDebounced = debounce(async (e) => await this.initPositioning(e), 200, {
                trailing: true,
            });
            this.initHeaderCoordinatesDebounced = debounce(() => this.initHeaderCoordinates(), 1000, {
                leading: true,
                trailing: false,
            });
            this.initialHeaderTop = null;
            this.handleScroll = () => {
                var _a;
                const tabHeader = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-tab-header');
                const scrollPosition = document.body.scrollTop;
                const layout = document.querySelector('sds-layout');
                const shadowRoot = layout.shadowRoot;
                const layoutContent = shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.querySelector('.sds-layout__content');
                if (tabHeader) {
                    if (this.initialHeaderTop === null) {
                        this.initialHeaderTop = tabHeader.offsetTop;
                    }
                    if (scrollPosition >= this.initialHeaderTop) {
                        tabHeader.classList.add('sds-tab-header--fixed');
                        layoutContent.classList.add('sds-tab-header--fixed');
                    }
                    else {
                        tabHeader.classList.remove('sds-tab-header--fixed');
                        layoutContent.classList.remove('sds-tab-header--fixed');
                    }
                }
            };
        }
        get isFixedHeader() { return __classPrivateFieldGet(this, _SdsTabs_isFixedHeader_accessor_storage, "f"); }
        set isFixedHeader(value) { __classPrivateFieldSet(this, _SdsTabs_isFixedHeader_accessor_storage, value, "f"); }
        get _selectedTabIndex() { return __classPrivateFieldGet(this, _SdsTabs__selectedTabIndex_accessor_storage, "f"); }
        set _selectedTabIndex(value) { __classPrivateFieldSet(this, _SdsTabs__selectedTabIndex_accessor_storage, value, "f"); }
        get _tabTitles() { return __classPrivateFieldGet(this, _SdsTabs__tabTitles_accessor_storage, "f"); }
        set _tabTitles(value) { __classPrivateFieldSet(this, _SdsTabs__tabTitles_accessor_storage, value, "f"); }
        get _panels() { return __classPrivateFieldGet(this, _SdsTabs__panels_accessor_storage, "f"); }
        set _panels(value) { __classPrivateFieldSet(this, _SdsTabs__panels_accessor_storage, value, "f"); }
        get _transform() { return __classPrivateFieldGet(this, _SdsTabs__transform_accessor_storage, "f"); }
        set _transform(value) { __classPrivateFieldSet(this, _SdsTabs__transform_accessor_storage, value, "f"); }
        get _sdsTabPrev() { return __classPrivateFieldGet(this, _SdsTabs__sdsTabPrev_accessor_storage, "f"); }
        set _sdsTabPrev(value) { __classPrivateFieldSet(this, _SdsTabs__sdsTabPrev_accessor_storage, value, "f"); }
        get _sdsTabNext() { return __classPrivateFieldGet(this, _SdsTabs__sdsTabNext_accessor_storage, "f"); }
        set _sdsTabNext(value) { __classPrivateFieldSet(this, _SdsTabs__sdsTabNext_accessor_storage, value, "f"); }
        get _sdsHeaderDiv() { return __classPrivateFieldGet(this, _SdsTabs__sdsHeaderDiv_accessor_storage, "f"); }
        set _sdsHeaderDiv(value) { __classPrivateFieldSet(this, _SdsTabs__sdsHeaderDiv_accessor_storage, value, "f"); }
        get _slotElement() { return __classPrivateFieldGet(this, _SdsTabs__slotElement_accessor_storage, "f"); }
        set _slotElement(value) { __classPrivateFieldSet(this, _SdsTabs__slotElement_accessor_storage, value, "f"); }
        get selectedTabIndex() {
            return this._selectedTabIndex ? this._selectedTabIndex : 0;
        }
        /**
         * Sets or reflects the index of the currently selected tab.
         *
         * Minimum value is `0`.
         *
         * @attr {number} selected-tab-index - Current selected tab index. Defaults to `undefined`.
         */
        set selectedTabIndex(index) {
            if (this._tabTitles.length !== 0) {
                if (!this._tabTitles[index].disabled && this._selectedTabIndex !== index) {
                    this._selectedTabIndex = index;
                    this.selectTab(this._tabTitles[index]);
                }
            }
            else {
                this._selectedTabIndex = index;
            }
        }
        async firstUpdated() {
            await this.updateComplete;
            appendStylesToTheStyleRoot(this, 'sds-tabs', this._stylesGlobal.cssText);
            this.correctRoles();
            if (!isNil(this._selectedTabIndex)) {
                this.selectTab(this._tabTitles[this._selectedTabIndex]);
            }
            this._tabTitles.forEach(title => {
                title.addEventListener('click', event => this.onTitleClick(event));
                title.addEventListener('keydown', event => this.onKeyDown(event));
            });
            this._panels.forEach(panel => {
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('tabindex', '0');
            });
            window.addEventListener('resize', (event) => void this.initPositioningDebounced(event));
            window.addEventListener('load', () => void this.initPositioningDebounced());
            this._sdsHeaderDiv.addEventListener('touchstart', (touchEvent) => {
                if (this._sdsTabPrev.style.display !== 'none' ||
                    this._sdsTabNext.style.display !== 'none') {
                    this.touchStartHandler(touchEvent);
                }
            });
            this._sdsHeaderDiv.addEventListener('touchmove', (touchEvent) => {
                if (this._sdsTabPrev.style.display !== 'none' ||
                    this._sdsTabNext.style.display !== 'none') {
                    this.touchMoveHandler(touchEvent);
                }
            });
            this._sdsHeaderDiv.addEventListener('touchend', () => {
                this._slotElement.className = 'sds-tab-header__labels';
            });
            this.directionChangeObserver.observe(document.documentElement, {
                attributeFilter: ['dir'],
                attributeOldValue: true,
            });
        }
        async updated() {
            await this.updateComplete;
            if (isNil(this._sdsFirstTabCoordinates) && isNil(this._sdsLastTabCoordinates)) {
                this.initPositioningDebounced();
            }
        }
        async connectedCallback() {
            super.connectedCallback();
            await this.updateComplete;
            this.initPositioningDebounced();
            if (this.isFixedHeader) {
                document.body.addEventListener('scroll', this.handleScroll);
            }
        }
        disconnectedCallback() {
            document.body.removeEventListener('scroll', this.handleScroll);
            super.disconnectedCallback();
            this.directionChangeObserver.disconnect();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        closeTabsMenu() {
            for (const tabTitle of this._tabTitles) {
                tabTitle.removeTriggerSelected();
            }
        }
        render() {
            return html `
            <div class="sds-tab-group">
                <div id="sds-tab-header" class="sds-tab-header" part="sds-tab-header">
                    <div id="sds-tab-prev" class="sds-tab__prev" style="display: none">
                        <sds-button
                            class="sds-tab__prev-btn"
                            type="secondary"
                            exportparts="sds-button:sds-button-inner"
                            size="sm"
                            icon="arrow_left_thin"
                            @click="${() => this.clickHandler(this._moveLength)}"
                        ></sds-button>
                    </div>
                    <slot
                        id="slot"
                        name="title"
                        class="sds-tab-header__labels"
                        style="transform: translateX(${this._transform.toString() + 'px'});"
                    ></slot>
                    <div id="sds-tab-next" class="sds-tab__next" style="display: none">
                        <sds-button
                            class="sds-tab__next-btn"
                            exportparts="sds-button:sds-button-inner"
                            type="secondary"
                            size="sm"
                            icon="arrow_right_thin"
                            @click="${() => this.clickHandler(-this._moveLength)}"
                        ></sds-button>
                    </div>
                </div>
                <div class="sds-tab-content">
                    <slot name="content" part="sds-tab-content"></slot>
                </div>
            </div>
        `;
        }
        onTitleClick(event) {
            const target = event.currentTarget;
            if (target.slot === 'title') {
                this.selectedTabIndex = this._tabTitles.indexOf(target);
                target.focus();
            }
        }
        onKeyDown(event) {
            let index;
            switch (event.code) {
                case 'ArrowUp':
                case 'ArrowLeft':
                    event.preventDefault();
                    index = this.selectedTabIndex - 1;
                    index = index < 0 ? this._tabTitles.length - 1 : index;
                    this.selectedTabIndex = index;
                    break;
                case 'ArrowDown':
                case 'ArrowRight':
                    event.preventDefault();
                    index = this.selectedTabIndex + 1;
                    index = index >= this._tabTitles.length ? 0 : index;
                    this.selectedTabIndex = index;
                    break;
                case 'Enter':
                case 'NumpadEnter':
                    event.preventDefault();
                    document.activeElement
                        ? (this.selectedTabIndex = this._tabTitles.indexOf(document.activeElement))
                        : (this.selectedTabIndex = 0);
                    break;
                default:
                    break;
            }
        }
        correctRoles() {
            this.setAttribute('role', 'tablist');
            this._tabTitles.forEach(tab => {
                tab.setAttribute('role', 'tab');
            });
        }
        selectTab(selectedTab) {
            for (const [index, tab] of this._tabTitles.entries()) {
                if (tab === selectedTab) {
                    tab.setAttribute('tabindex', '-1');
                    tab.setAttribute('aria-selected', 'true');
                    this._panels[index].setAttribute('aria-hidden', 'false');
                    this._panels[index].style.display = '';
                }
                else {
                    if (tab.disabled) {
                        tab.setAttribute('tabindex', '-1');
                    }
                    else {
                        tab.setAttribute('tabindex', '0');
                    }
                    tab.setAttribute('aria-selected', 'false');
                    this._panels[index].setAttribute('aria-hidden', 'true');
                    this._panels[index].style.display = 'none';
                }
            }
            this.dispatchEvent(new CustomEvent(SdsTabs.SELECTED_EVENT, {
                detail: {
                    selectedTabIndex: this.selectedTabIndex,
                },
                bubbles: true,
                composed: true,
            }));
        }
        async initPositioning(event) {
            if (this.headerCoordinatesFixed()) {
                this.initHeaderCoordinates();
                this.initTabCoordinates();
                this.showTabArrowsIfNeeded();
                await this.initTabsPosition(event);
            }
            else {
                this.initPositioningDebounced();
            }
        }
        async initTabsPosition(event) {
            const currentWindowWidth = await fastDom.measure(() => {
                return event && event.view ? event.view.innerWidth : window.innerWidth;
            });
            if (isNil(this._windowWidth)) {
                this._windowWidth = currentWindowWidth;
            }
            if (currentWindowWidth - this._windowWidth > 0) {
                const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
                if (isRtl) {
                    const distanceToMove = this._sdsHeaderDivCoordinates.distanceToMove(this._windowWidth - currentWindowWidth, this._sdsLastTabCoordinates, this._sdsFirstTabCoordinates);
                    if (this.isMoveNeededAfterResize(distanceToMove)) {
                        await fastDom.mutate(() => (this._transform += this.moveTabsRtl(currentWindowWidth - this._windowWidth)));
                    }
                }
                else {
                    const distanceToMove = this._sdsHeaderDivCoordinates.distanceToMove(currentWindowWidth - this._windowWidth, this._sdsFirstTabCoordinates, this._sdsLastTabCoordinates);
                    if (this.isMoveNeededAfterResize(distanceToMove)) {
                        await fastDom.mutate(() => (this._transform += this.moveTabsLtr(currentWindowWidth - this._windowWidth)));
                    }
                }
            }
            this._windowWidth = window.innerWidth;
        }
        isMoveNeededAfterResize(distanceToMove) {
            return (this._sdsHeaderDivCoordinates.isTabInViewport(this._sdsLastTabCoordinates, distanceToMove) && !this._sdsHeaderDivCoordinates.isTabInViewport(this._sdsFirstTabCoordinates));
        }
        clickHandler(distance) {
            this.initHeaderCoordinatesDebounced();
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
            if (isRtl) {
                this._transform += this.moveTabsRtl(distance);
            }
            else {
                this._transform += this.moveTabsLtr(distance);
            }
        }
        moveTabsRtl(distance) {
            return this._sdsHeaderDivCoordinates.moveTabs(-distance, this._sdsLastTabCoordinates, this._sdsFirstTabCoordinates);
        }
        moveTabsLtr(distance) {
            return this._sdsHeaderDivCoordinates.moveTabs(distance, this._sdsFirstTabCoordinates, this._sdsLastTabCoordinates);
        }
        showTabArrowsIfNeeded() {
            this.toggleArrow(this._sdsLastTabCoordinates, this._sdsTabNext);
            this.toggleArrow(this._sdsFirstTabCoordinates, this._sdsTabPrev);
        }
        toggleArrow(tabRect, arrow) {
            this._sdsHeaderDivCoordinates.isTabInViewport(tabRect)
                ? (arrow.style.display = 'none')
                : (arrow.style.display = '');
        }
        touchStartHandler(touchEvent) {
            this._slotElement.className = 'sds-tab-header__labels-touch';
            this._currentTouchCoordinate = touchEvent.touches[0].clientX;
        }
        touchMoveHandler(touchEvent) {
            this.initHeaderCoordinatesDebounced();
            const touchMoved = touchEvent.touches[0].clientX - this._currentTouchCoordinate;
            this._currentTouchCoordinate = touchEvent.touches[0].clientX;
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
            if (isRtl) {
                this._transform += this._sdsHeaderDivCoordinates.moveTabs(touchMoved, this._sdsLastTabCoordinates, this._sdsFirstTabCoordinates);
            }
            else {
                this._transform += this._sdsHeaderDivCoordinates.moveTabs(touchMoved, this._sdsFirstTabCoordinates, this._sdsLastTabCoordinates);
            }
        }
        initTabCoordinates() {
            if (isNil(this._sdsFirstTabCoordinates) ||
                this._sdsFirstTabCoordinates.tab.hasAttribute('hidden')) {
                for (let i = 0; i < this._tabTitles.length; ++i) {
                    if (!this._tabTitles[i].hasAttribute('hidden')) {
                        this._sdsFirstTabCoordinates = new TabRect(this._tabTitles[i]);
                        break;
                    }
                }
            }
            else {
                this._sdsFirstTabCoordinates.calculateCoordinates();
            }
            if (isNil(this._sdsLastTabCoordinates) ||
                this._sdsLastTabCoordinates.tab.hasAttribute('hidden')) {
                for (let i = this._tabTitles.length - 1; i >= 0; --i) {
                    if (!this._tabTitles[i].hasAttribute('hidden')) {
                        this._sdsLastTabCoordinates = new TabRect(this._tabTitles[i]);
                        break;
                    }
                }
            }
            else {
                this._sdsLastTabCoordinates.calculateCoordinates();
            }
        }
        headerCoordinatesFixed() {
            if (this._sdsHeaderDivCoordinates) {
                const oldHeaderLeft = this._sdsHeaderDivCoordinates.left;
                const oldHeaderRight = this._sdsHeaderDivCoordinates.right;
                this.initHeaderCoordinates();
                return (oldHeaderLeft === this._sdsHeaderDivCoordinates.left &&
                    oldHeaderRight === this._sdsHeaderDivCoordinates.right);
            }
            else {
                this.initHeaderCoordinates();
            }
            return false;
        }
        initHeaderCoordinates() {
            if (isNil(this._sdsHeaderDivCoordinates)) {
                this._sdsHeaderDivCoordinates = new TabContainer(this._sdsHeaderDiv, this._sdsTabPrev, this._sdsTabNext);
            }
            else {
                this._sdsHeaderDivCoordinates.calculateCoordinates();
            }
        }
    };
    _SdsTabs_isFixedHeader_accessor_storage = new WeakMap();
    _SdsTabs__selectedTabIndex_accessor_storage = new WeakMap();
    _SdsTabs__tabTitles_accessor_storage = new WeakMap();
    _SdsTabs__panels_accessor_storage = new WeakMap();
    _SdsTabs__transform_accessor_storage = new WeakMap();
    _SdsTabs__sdsTabPrev_accessor_storage = new WeakMap();
    _SdsTabs__sdsTabNext_accessor_storage = new WeakMap();
    _SdsTabs__sdsHeaderDiv_accessor_storage = new WeakMap();
    _SdsTabs__slotElement_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTabs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isFixedHeader_decorators = [property({ type: Boolean, attribute: 'fixed-header', reflect: true })];
        __selectedTabIndex_decorators = [property({ type: Number, attribute: 'selected-tab-index', reflect: true })];
        __tabTitles_decorators = [queryAssignedElements({ slot: 'title', flatten: false })];
        __panels_decorators = [queryAssignedElements({ slot: 'content', flatten: false })];
        __transform_decorators = [state()];
        __sdsTabPrev_decorators = [query('#sds-tab-prev')];
        __sdsTabNext_decorators = [query('#sds-tab-next')];
        __sdsHeaderDiv_decorators = [query('#sds-tab-header')];
        __slotElement_decorators = [query('#slot')];
        _set_selectedTabIndex_decorators = [property({ type: Number, attribute: 'selected-tab-index', reflect: true })];
        __esDecorate(_classThis, null, _isFixedHeader_decorators, { kind: "accessor", name: "isFixedHeader", static: false, private: false, access: { has: obj => "isFixedHeader" in obj, get: obj => obj.isFixedHeader, set: (obj, value) => { obj.isFixedHeader = value; } }, metadata: _metadata }, _isFixedHeader_initializers, _isFixedHeader_extraInitializers);
        __esDecorate(_classThis, null, __selectedTabIndex_decorators, { kind: "accessor", name: "_selectedTabIndex", static: false, private: false, access: { has: obj => "_selectedTabIndex" in obj, get: obj => obj._selectedTabIndex, set: (obj, value) => { obj._selectedTabIndex = value; } }, metadata: _metadata }, __selectedTabIndex_initializers, __selectedTabIndex_extraInitializers);
        __esDecorate(_classThis, null, __tabTitles_decorators, { kind: "accessor", name: "_tabTitles", static: false, private: false, access: { has: obj => "_tabTitles" in obj, get: obj => obj._tabTitles, set: (obj, value) => { obj._tabTitles = value; } }, metadata: _metadata }, __tabTitles_initializers, __tabTitles_extraInitializers);
        __esDecorate(_classThis, null, __panels_decorators, { kind: "accessor", name: "_panels", static: false, private: false, access: { has: obj => "_panels" in obj, get: obj => obj._panels, set: (obj, value) => { obj._panels = value; } }, metadata: _metadata }, __panels_initializers, __panels_extraInitializers);
        __esDecorate(_classThis, null, __transform_decorators, { kind: "accessor", name: "_transform", static: false, private: false, access: { has: obj => "_transform" in obj, get: obj => obj._transform, set: (obj, value) => { obj._transform = value; } }, metadata: _metadata }, __transform_initializers, __transform_extraInitializers);
        __esDecorate(_classThis, null, __sdsTabPrev_decorators, { kind: "accessor", name: "_sdsTabPrev", static: false, private: false, access: { has: obj => "_sdsTabPrev" in obj, get: obj => obj._sdsTabPrev, set: (obj, value) => { obj._sdsTabPrev = value; } }, metadata: _metadata }, __sdsTabPrev_initializers, __sdsTabPrev_extraInitializers);
        __esDecorate(_classThis, null, __sdsTabNext_decorators, { kind: "accessor", name: "_sdsTabNext", static: false, private: false, access: { has: obj => "_sdsTabNext" in obj, get: obj => obj._sdsTabNext, set: (obj, value) => { obj._sdsTabNext = value; } }, metadata: _metadata }, __sdsTabNext_initializers, __sdsTabNext_extraInitializers);
        __esDecorate(_classThis, null, __sdsHeaderDiv_decorators, { kind: "accessor", name: "_sdsHeaderDiv", static: false, private: false, access: { has: obj => "_sdsHeaderDiv" in obj, get: obj => obj._sdsHeaderDiv, set: (obj, value) => { obj._sdsHeaderDiv = value; } }, metadata: _metadata }, __sdsHeaderDiv_initializers, __sdsHeaderDiv_extraInitializers);
        __esDecorate(_classThis, null, __slotElement_decorators, { kind: "accessor", name: "_slotElement", static: false, private: false, access: { has: obj => "_slotElement" in obj, get: obj => obj._slotElement, set: (obj, value) => { obj._slotElement = value; } }, metadata: _metadata }, __slotElement_initializers, __slotElement_extraInitializers);
        __esDecorate(_classThis, null, _set_selectedTabIndex_decorators, { kind: "setter", name: "selectedTabIndex", static: false, private: false, access: { has: obj => "selectedTabIndex" in obj, set: (obj, value) => { obj.selectedTabIndex = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTabs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SELECTED_EVENT = 'sds.tabs.selected';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTabs = _classThis;
})();
export { SdsTabs };
class TabContainer {
    constructor(container, sdsTabPrev, sdsTabNext) {
        this._container = container;
        this._sdsTabPrev = sdsTabPrev;
        this._sdsTabNext = sdsTabNext;
        this.calculateCoordinates();
    }
    get left() {
        return this._left;
    }
    get right() {
        return this._right;
    }
    get top() {
        return this._top;
    }
    get bottom() {
        return this._bottom;
    }
    calculateCoordinates() {
        const coordinates = this._container.getBoundingClientRect();
        const containerStyle = getComputedStyle(this._container);
        this._left = coordinates.left + parseInt(containerStyle.paddingLeft);
        this._right = coordinates.right - parseInt(containerStyle.paddingRight);
        this._top = coordinates.top;
        this._bottom = coordinates.bottom;
    }
    moveTabs(distance, firstTab, lastTab) {
        firstTab.calculateCoordinates();
        lastTab.calculateCoordinates();
        const distanceToMove = this.distanceToMove(distance, firstTab, lastTab);
        this.showTabArrowsIfNeeded(distanceToMove, firstTab, lastTab);
        return distanceToMove;
    }
    distanceToMove(distance, firstTab, lastTab) {
        if (this.isOutOfBounds(distance, firstTab, lastTab)) {
            if (distance > 0) {
                return this.distanceToRight(firstTab);
            }
            else if (distance < 0) {
                return this.distanceToLeft(lastTab);
            }
        }
        return distance;
    }
    isTabInViewport(tabRect, distance = 0) {
        return (tabRect &&
            roundTabCoordinates(tabRect.left + distance) >= roundTabCoordinates(this._left) &&
            roundTabCoordinates(tabRect.right + distance) <= roundTabCoordinates(this._right));
    }
    isOutOfBounds(distance, firstTab, lastTab) {
        return distance > 0
            ? firstTab.left + distance >= this._left
            : lastTab.right + distance <= this._right;
    }
    distanceToLeft(lastTab) {
        return this._right - lastTab.right;
    }
    distanceToRight(firstTab) {
        return this._left - firstTab.left;
    }
    showTabArrowsIfNeeded(distance, firstTab, lastTab) {
        const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
        if (isRtl) {
            this.isTabInViewport(lastTab, distance)
                ? (this._sdsTabPrev.style.display = 'none')
                : (this._sdsTabPrev.style.display = '');
            this.isTabInViewport(firstTab, distance)
                ? (this._sdsTabNext.style.display = 'none')
                : (this._sdsTabNext.style.display = '');
        }
        else {
            this.isTabInViewport(lastTab, distance)
                ? (this._sdsTabNext.style.display = 'none')
                : (this._sdsTabNext.style.display = '');
            this.isTabInViewport(firstTab, distance)
                ? (this._sdsTabPrev.style.display = 'none')
                : (this._sdsTabPrev.style.display = '');
        }
    }
}
class TabRect {
    constructor(tab) {
        this.tab = tab;
        this.calculateCoordinates();
    }
    calculateCoordinates() {
        const coordinates = this.tab.getBoundingClientRect();
        this.left = coordinates.left;
        this.right = coordinates.right;
        this.top = coordinates.top;
        this.bottom = coordinates.bottom;
    }
}
